/**
 * @fileoverview Agent definition for synopsis-extraction-pipeline-v3.
 *
 * Composite agent that orchestrates synopsis extraction with automatic
 * size-based routing:
 *
 * - Small documents (≤400k chars): single-pass via plot-synopsis-extractor-v3
 * - Large documents (>400k chars): chunked map-reduce via
 *   plot-synopsis-extractor-chunked-v3 (parallel map) +
 *   plot-synopsis-merge-v3 (reduce)
 *
 * @category import.story.synopsis
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
export const definition: AppAgentDefinition = {
  id: 'synopsis-extraction-pipeline-v3',
  kind: 'composite',
  name: 'Synopsis Extraction Pipeline',
  description: 'Extracts a synopsis from source text. Automatically uses chunked map-reduce for large documents (>400k chars).',
  category: 'import',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'import.story.synopsis',
    usedBy: [
      'use-plot-synopsis-extractor-v3.ts',
      'use-long-form-import.ts',
    ],
    composedOf: [
      'plot-synopsis-extractor-v3',
      'plot-synopsis-extractor-chunked-v3',
      'plot-synopsis-merge-v3',
    ],
    relatedAgents: [],
  },
};
